// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_sIg3f","dangerous":"view-default_dangerous_1nxmK"};